<template>
  <div style="padding: 2vh 1.5vw;">
    <el-row class="content-head">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>广播</el-breadcrumb-item>
            <el-breadcrumb-item>广播列表</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="text-align: left;margin: 2vh 0;">
        <span style="margin-right: 1vw;">广播名称: </span>
        <el-input placeholder="请输入广播名称" v-model="name" size="small" clearable>
          <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
        </el-input>
      </el-col>
    </el-row>
   <el-card>
    <el-table
      stripe
      :data="tableData"
      height="65vh"
      style="width: 100%">
      <el-table-column
        label="序号"
        type="index"
        :index="1"
        width="80">
      </el-table-column>
      <el-table-column
        prop="name"
        label="广播名称"
        width="180">
      </el-table-column>
      <el-table-column
        prop="id"
        label="广播id"
        width="250">
      </el-table-column>
      <el-table-column
        prop="serial"
        label="设备序列号">
      </el-table-column>
      <el-table-column
        prop="createDate"
        label="创建时间">
      </el-table-column>
      <el-table-column
      prop="remarks"
      label="备注">
    </el-table-column>
    <el-table-column label="操作">
      <template slot-scope="scope">
        <el-button
          v-if="scope.row.machType == 3"
          plain
          type="primary"
          size="mini"
          @click="handleEdit(scope.$index, scope.row)">查看广播任务</el-button>
      </template>
    </el-table-column>
    </el-table>
    <el-pagination
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    :current-page="1"
    :page-sizes="[5, 10, 20, 50]"
    :page-size="10"
    layout="total, sizes, prev, pager, next, jumper"
    :total="total">
  </el-pagination>
   </el-card>
  </div>
</template>
<script>
import myHttp from '../untils/port.js'
import util from '../untils/util.js'
export default {
  data() {
    return {
      tableData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      name: ''
    }
  },
  created() {
    this.getbroadcastList();
  },
  methods: {
    //获取广播列表
    getbroadcastList(){
      myHttp.getBroadcastList({
        name: this.name,
        projectId: util.session.get('groupId'),
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }).then(resp => {
        console.log(resp);
        if(resp.data.code == '200') {
          this.tableData = resp.data.data.pageInfo.list
          this.total = resp.data.data.pageInfo.total
        }
      })
    },
    //搜索广播列表
    search(){
      this.getbroadcastList();
    },
    handleEdit(index, row){
      this.$router.push({
        path: `/broadcastTask`,
        query: {
          id: row.serial
        }
      })
    },
    handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.pageSize = val
        this.getbroadcastList();
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.pageNum = val
        this.getbroadcastList();
      }
  },
}
</script>
<style scoped>

@import '../assets/css/common.css';
</style>